import Vue from "vue";
import Router from "vue-router";
import router from "@/router";

import { constantRouterMap } from "@/router/index";

export function resetRouter() {
  router.options.routes = [];
  router.matcher = new Router({
    // 重置路由规则
    routes: constantRouterMap
  }).matcher;
}



// WEBPACK FOOTER //
// ./src/router/resetRouter.js